import { useState, useEffect } from "react";
import { createModel } from "hox";
import { useSessionStorageState } from "ahooks";
import { useGlobalModel } from "@/model/globalModel";
import { dictService, IMdDictFields } from "@/views/base/dict/dictService";
import { IMdOrgDetail, orgService } from "@/views/base/org/orgService";
import { beService } from "@/views/base/be/beService";
import { ITreeData } from "@/views/base/dict/dictModel";
import { OptionDsType } from "@/types/FmsTypes";

export enum DetailActionTypeEnum {
    ACCOUNT,
    OPEN,
    ADJUST,
    RECHARGE,
    CONTRACT,
    STATEMENT,
    BILL
}

type labelsType = {
    [proppName: string]: string;
}
export const useDetailModel = createModel(function () {
    const { user } = useGlobalModel();
    const [actionType, setActionType] = useSessionStorageState<number>("contract.detail.type", DetailActionTypeEnum.CONTRACT) // 选中展示模块

    const [customerCode, setCustomerCode] = useSessionStorageState<string>("contract.detail.customerCode", "");
    const [title, setTitle] = useSessionStorageState<string>("contract.detail.title", "");

    //数据字典解析
    const [dictLabels, setDictLabels] = useState<labelsType>({});

    const [orgDs, setOrgDs] = useState<ITreeData<IMdOrgDetail>[]>();
    const [beDs, setBeDs] = useState<OptionDsType[]>();
    const [payMethodDs, setPayMethodDs] = useState<ITreeData<IMdDictFields>[]>();

    useEffect(() => {
        orgService.orgTreeDs({}).then(ds => { setOrgDs(ds) })
        beService.beDs({}).then(ds => setBeDs(ds))
        dictService.accountTreeOne("pay-method").then(ds => setPayMethodDs(ds))
    }, []);

    const loadLabel = () => {
        dictService.dictItemDs("settle-type").then(ds => {
            let obj: labelsType = {}
            ds.forEach(item => {
                obj[item.value] = item.label
            })
            setDictLabels({ ...dictLabels, ...obj })
        })
    }


    return {
        user, orgDs, beDs, payMethodDs,
        actionType, setActionType,
        title, setTitle,
        customerCode, setCustomerCode,
        dictLabels, loadLabel,
    }
});
